import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function CalendarRenderer({ element }: RendererProps) {
  const { dispatchEvent } = useRenderContext()

  const kids = element.children ?? []

  return (
    <div
      className={cn("flex flex-col gap-2 p-4 bg-card rounded-lg border border-border", element.className)}
      data-testid={`calendar-${element.id}`}
      role="grid"
      aria-label="Calendar"
    >
      {kids.map((child) => (
        <ElementRenderer key={child.id} element={child} />
      ))}
    </div>
  )
}
